// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { BaseGannDataCacheTool } from "./BaseGannDataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let GannLineDataCacheTool = function ()
{
    BaseGannDataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.GannLine;
    this.InitPoints(1);
};

GannLineDataCacheTool.prototype = Object.create(BaseGannDataCacheTool.prototype);

GannLineDataCacheTool.prototype.MaxPointsCount = function () { return 1; };
GannLineDataCacheTool.prototype.MinPointsCount = function () { return 1; };

//#region ICaller

GannLineDataCacheTool.prototype.Properties = function ()
{
    var props = BaseGannDataCacheTool.prototype.Properties.apply(this);
    props.push(new DynProperty("chart.tools.mirrored", this.mirrored, DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP));
    return props;
};

GannLineDataCacheTool.prototype.callBack = function (properties)
{
    BaseGannDataCacheTool.prototype.callBack.call(this, properties);
    var prop = DynProperty.getPropertyByName(properties, "chart.tools.mirrored");
    if (prop) this.mirrored = prop.value;
};

//#endregion